import {Log, WebStorageStateStore} from 'oidc-client-ts';

const getAuthConfig = () => {
    Log.setLogger(console);
    Log.setLevel(Log.WARN);

    const authProvider = process.env.REACT_APP_AUTH_PROVIDER || 'keycloak';
    const redirectRoot = window.location.origin;
    const keycloakBaseUrl = process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080/realms/your-realm';
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'react-admin';

    const baseConfig = {
        silent_redirect_uri: `${redirectRoot}/authentication/silent-callback`,
        authority: '',
        client_id: '',
        redirect_uri: `${redirectRoot}/authentication/callback`,
        post_logout_redirect_uri: redirectRoot,
        response_type: 'code',
        scope: 'openid profile email',
        automaticSilentRenew: true,
        silentRequestTimeout: 10000,
        accessTokenExpiringNotificationTime: 600,
        monitorSession: false,
        silentRequestUsingForm: true,
        loadUserInfo: true,
        filterProtocolClaims: true,
        revokeAccessTokenOnSignout: true,
        userStore: new WebStorageStateStore({store: window.localStorage}),
        onSigninStart: request => console.log('Signin started', request),
        onSignoutStart: request => console.log('Signout started', request),
        onAccessTokenExpiring: () => console.log('Access token is about to expire'),
        onAccessTokenExpired: () => window.location.reload(),
        onSilentRenewError: error => console.error('Silent token renewal error', error)
    };

    const providerConfigs = {
        keycloak: {
            authority: keycloakBaseUrl,
            client_id: clientId,
            metadata: {
                issuer: keycloakBaseUrl,
                authorization_endpoint: `${keycloakBaseUrl}/protocol/openid-connect/auth`,
                token_endpoint: `${keycloakBaseUrl}/protocol/openid-connect/token`,
                userinfo_endpoint: `${keycloakBaseUrl}/protocol/openid-connect/userinfo`,
                end_session_endpoint: `${keycloakBaseUrl}/protocol/openid-connect/logout`,
                jwks_uri: `${keycloakBaseUrl}/protocol/openid-connect/certs`,
            },
            usePkce: true
        }
    };

    return {...baseConfig, ...providerConfigs[authProvider]};
};

export default getAuthConfig;
